/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyRolesResponse } from '../../models/company-roles-response';

export interface GetCompanyRoles$Params {
}

export function getCompanyRoles(http: HttpClient, rootUrl: string, params?: GetCompanyRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyRolesResponse>>> {
  const rb = new RequestBuilder(rootUrl, getCompanyRoles.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyRolesResponse>>;
    })
  );
}

getCompanyRoles.PATH = '/api/company-roles';
